import { z } from "zod";
import { AdminListInputSchema, adminListOutput } from "./common";

// =============
// Admin Audit Log Schemas
// =============

/**
 * Audit log action types.
 */
export const AuditLogActionSchema = z.enum([
	"create",
	"update",
	"delete",
	"restore",
	"ban",
	"unban",
	"role_change",
]);
export type AuditLogAction = z.infer<typeof AuditLogActionSchema>;

/**
 * Audit log resource types.
 */
export const AuditLogResourceTypeSchema = z.enum([
	"app",
	"partner",
	"referral_link",
	"payout",
	"billing_entity",
	"user",
]);
export type AuditLogResourceType = z.infer<typeof AuditLogResourceTypeSchema>;

/**
 * Audit log schema.
 */
export const AdminAuditLogSchema = z.object({
	id: z.string(),
	actorId: z.string(),
	actorEmail: z.string(),
	action: AuditLogActionSchema,
	resourceType: AuditLogResourceTypeSchema,
	resourceId: z.string(),
	previousState: z.unknown().nullable(),
	newState: z.unknown().nullable(),
	ipAddress: z.string().nullable(),
	userAgent: z.string().nullable(),
	createdAt: z.coerce.date(),
	expiresAt: z.coerce.date(),
});
export type AdminAuditLog = z.infer<typeof AdminAuditLogSchema>;

/**
 * Audit log list input with filters.
 */
export const AdminAuditLogListInputSchema = AdminListInputSchema.extend({
	filter: z
		.object({
			actorId: z.string().optional(),
			action: AuditLogActionSchema.optional(),
			resourceType: AuditLogResourceTypeSchema.optional(),
			resourceId: z.string().optional(),
			createdAfter: z.coerce.date().optional(),
			createdBefore: z.coerce.date().optional(),
		})
		.optional(),
});
export type AdminAuditLogListInput = z.infer<
	typeof AdminAuditLogListInputSchema
>;

/**
 * Audit log list output.
 */
export const AdminAuditLogListOutputSchema =
	adminListOutput(AdminAuditLogSchema);
export type AdminAuditLogListOutput = z.infer<
	typeof AdminAuditLogListOutputSchema
>;
